import { render } from "./AtelierEdit.vue?vue&type=template&id=07e2d3ea"
import script from "./AtelierEdit.vue?vue&type=script&lang=js"
export * from "./AtelierEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__